export default "__VITE_ASSET__Dcg0XcyD__"